import { PartyPopper, Trophy, X } from "lucide-react";

const confetti = Array.from({ length: 18 }, (_, index) => index);

export const Celebration = ({ kind, onClose }) => {
  const completed = kind === "complete";
  const heading = completed ? "Desafio concluído!" : "Mais um passo guardado!";
  const body = completed
    ? "Você completou todos os quadradinhos. Que orgulho da sua conquista!"
    : "Seu cofrinho está crescendo. Continue nesse ritmo!";

  return (
    <div
      data-testid="celebration-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="celebration-title"
      className="celebration-backdrop"
    >
      <div className="celebration-confetti" aria-hidden="true">
        {confetti.map((piece) => (
          <i key={piece} style={{ "--piece": piece }} />
        ))}
      </div>
      <section className="celebration-panel">
        <button
          type="button"
          onClick={onClose}
          data-testid="celebration-close-icon-button"
          className="absolute right-4 top-4 grid h-11 w-11 place-items-center rounded-full text-emerald-950 transition-colors hover:bg-emerald-100"
          aria-label="Fechar comemoração"
        >
          <X className="h-6 w-6" />
        </button>
        <div className="celebration-medal" aria-hidden="true">
          {completed ? <Trophy className="h-12 w-12" /> : <PartyPopper className="h-12 w-12" />}
        </div>
        <h2 id="celebration-title" data-testid="celebration-title" className="mt-5 font-heading text-3xl font-extrabold text-emerald-950">
          {heading}
        </h2>
        <p data-testid="celebration-message" className="mt-3 text-lg leading-relaxed text-slate-700">
          {body}
        </p>
        <button
          type="button"
          onClick={onClose}
          data-testid="celebration-continue-button"
          className="mt-7 min-h-[56px] w-full rounded-xl bg-emerald-700 px-5 font-heading text-xl font-bold text-white shadow-[0_5px_0_#064e3b] transition-[transform,box-shadow,background-color] hover:bg-emerald-800 active:translate-y-1 active:shadow-[0_1px_0_#064e3b]"
        >
          {completed ? "Ver minha conquista" : "Continuar guardando"}
        </button>
      </section>
    </div>
  );
};